import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

export interface SuccessModalConfig {
  title: string;
  message: string;
  icon?: string;
  iconColor?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  showPrimaryButton?: boolean;
  showSecondaryButton?: boolean;
}

interface GenericSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  config: SuccessModalConfig;
}

const GenericSuccessModal: React.FC<GenericSuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  onPrimaryAction,
  onSecondaryAction,
  config
}) => {
  const toggle = () => onClose();

  const defaultConfig = {
    icon: 'bx bx-file',
    iconColor: '#0ab39c',
    primaryButtonText: 'Continuar',
    secondaryButtonText: 'Ver Lista',
    showPrimaryButton: true,
    showSecondaryButton: true,
    ...config
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      centered={true}
    >
      <ModalHeader toggle={toggle}>
        <div className="d-flex align-items-center">
          {defaultConfig.title}
        </div>
      </ModalHeader>

      <ModalBody>
        <div className="text-center py-3">
          <div className="mb-3">
            <i 
              className={defaultConfig.icon} 
              style={{ 
                fontSize: '4rem', 
                color: defaultConfig.iconColor 
              }}
            ></i>
          </div>
          
          <p className="text-muted fs-15 mb-4">
            {defaultConfig.message}
          </p>

          <div className="d-flex gap-2 justify-content-end">
            {defaultConfig.showSecondaryButton && (
              <Button 
                color="light"
                className="waves-effect waves-light"
                onClick={onSecondaryAction || onClose}
                style={{ minWidth: "140px" }}
              >
                {defaultConfig.secondaryButtonText}
              </Button>
            )}
            
            {defaultConfig.showPrimaryButton && (
              <Button 
                color="primary"
                className="btn-primary waves-effect"
                onClick={onPrimaryAction || onClose}
                style={{ minWidth: "140px" }}
              >
                {defaultConfig.primaryButtonText}
              </Button>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

// Funciones de ayuda para configuraciones específicas
export const createBillingSuccessConfig = (): SuccessModalConfig => ({
  title: "¡Factura Generada Exitosamente!",
  message: "La factura fue enviada al SRI. Revisa su estado en la lista de facturas para confirmar su autorización.",
  icon: 'bx bx-file',
  iconColor: '#0ab39c',
  primaryButtonText: 'Nueva Factura',
  secondaryButtonText: 'Ver Facturas',
  showPrimaryButton: true,
  showSecondaryButton: true
});

export const createRemissionGuideSuccessConfig = (): SuccessModalConfig => ({
  title: "¡Guía de Remisión Generada Exitosamente!",
  message: "La guía de remisión fue enviada al SRI. Revisa su estado en la lista de guías para confirmar su autorización.",
  icon: 'ri-truck-line',
  iconColor: '#0ab39c',
  primaryButtonText: 'Nueva Guía',
  secondaryButtonText: 'Ver Guías',
  showPrimaryButton: true,
  showSecondaryButton: true
});

export default GenericSuccessModal;
